// Admin Dashboard center registry — drives the sidebar and "coming soon" pages.
// Adding a new center later = add an entry here + a route; no shell redesign.

export const CENTER_GROUPS = [
  {
    label: "Operations",
    items: [
      { key: "command-center", name: "Command Center", icon: "Gauge", to: "/admin/command-center", built: true },
      { key: "crm-operations", name: "CRM Operations", icon: "Network", to: "/admin/crm-operations", built: true },
      { key: "jobs", name: "Scheduler & Jobs", icon: "CalendarClock", to: "/admin/jobs", built: true },
      { key: "intelligence", name: "Customer Intelligence", icon: "Sparkles", to: "/admin/intelligence", built: true },
      { key: "support", name: "Support Center", icon: "LifeBuoy", to: "/admin/support", built: true },
    ],
  },
  {
    label: "Governance & Security",
    items: [
      { key: "security", name: "Security Center", icon: "ShieldCheck", to: "/admin/security", built: true },
      { key: "audit", name: "Audit Center", icon: "ScrollText", to: "/admin/audit", built: true },
      { key: "risk", name: "Risk Center", icon: "AlertTriangle", to: "/admin/center/risk", built: false },
      { key: "policy", name: "Policy Center", icon: "FileText", to: "/admin/center/policy", built: false },
      { key: "incident", name: "Incident Center", icon: "Siren", to: "/admin/center/incident", built: false },
      { key: "vendor", name: "Vendor Center", icon: "Building2", to: "/admin/center/vendor", built: false },
    ],
  },
  {
    label: "Platform",
    items: [
      { key: "access", name: "User & Access", icon: "Users", to: "/admin/access", built: true },
      { key: "configuration", name: "Configuration", icon: "Settings", to: "/admin/configuration", built: true },
      { key: "analytics", name: "Business Intelligence", icon: "BarChart3", to: "/admin/analytics", built: true },
      { key: "environment", name: "Environment & Infra", icon: "Server", to: "/admin/center/environment", built: false },
      { key: "backup", name: "Backup & Recovery", icon: "DatabaseBackup", to: "/admin/center/backup", built: false },
      { key: "trust", name: "Trust Center", icon: "BadgeCheck", to: "/admin/center/trust", built: false },
    ],
  },
];

export const COMING_SOON = {
  "crm-operations": {
    name: "CRM Operations Center", icon: "Network",
    desc: "Provider-agnostic monitoring of every CRM connector and job queue.",
    capabilities: ["Connector health & status", "Connection failures", "Active & failed scan jobs", "Cleanup jobs", "Processing queue", "Write-back queue", "Synchronization activity"],
    depends: "Module 2 (write-back) & job engine",
  },
  intelligence: {
    name: "Customer Intelligence Center", icon: "Sparkles",
    desc: "Operational view of Engine Two enrichment activity.",
    capabilities: ["Intelligence requests", "Intelligence performance", "Credit usage", "Source confidence", "Pending approvals", "Historical activity"],
    depends: "Module 3 (Customer Intelligence Engine)",
  },
  risk: {
    name: "Risk Center", icon: "AlertTriangle",
    desc: "Track platform, technical, operational and security risks.",
    capabilities: ["Risk register", "Assigned owners", "Mitigation plans", "Resolution history", "Severity & likelihood scoring"],
    depends: "Governance module",
  },
  policy: {
    name: "Policy Center", icon: "FileText",
    desc: "Version-controlled operational policies.",
    capabilities: ["Security", "Privacy", "Data retention", "Access control", "Vendor management", "Incident response", "Change management", "Backup & recovery", "Business continuity"],
    depends: "Governance module",
  },
  incident: {
    name: "Incident Center", icon: "Siren",
    desc: "Manage the full incident lifecycle.",
    capabilities: ["Active incidents & severity", "Timeline & ownership", "Resolution", "Root cause", "Corrective actions", "Lessons learned"],
    depends: "Governance module",
  },
  vendor: {
    name: "Vendor Center", icon: "Building2",
    desc: "Third-party service registry and reviews.",
    capabilities: ["Vendor registry & docs", "Security reviews", "Criticality", "Contract renewals", "Risk ratings"],
    depends: "Governance module",
  },
  analytics: {
    name: "Platform Analytics", icon: "BarChart3",
    desc: "Trends across the platform.",
    capabilities: ["CRM health trends", "Customer adoption", "Platform usage", "Intelligence usage", "Credit consumption", "API & system performance"],
    depends: "Analytics pipeline",
  },
  environment: {
    name: "Environment & Infrastructure", icon: "Server",
    desc: "Runtime and infrastructure health.",
    capabilities: ["Deployments", "Background workers", "Scheduled jobs", "Queue health", "Feature flags", "Environment & infra status"],
    depends: "Infra/observability integration",
  },
  backup: {
    name: "Backup & Recovery Center", icon: "DatabaseBackup",
    desc: "Data protection and disaster recovery readiness.",
    capabilities: ["Backup status", "Restore verification", "Recovery readiness", "Disaster recovery health"],
    depends: "Infra/backup integration",
  },
  trust: {
    name: "Trust Center Management", icon: "BadgeCheck",
    desc: "Customer-facing trust resources.",
    capabilities: ["Security overview", "Privacy docs", "Terms of Service", "Compliance info", "Subprocessor registry", "Security FAQs", "Platform status"],
    depends: "Content & compliance module",
  },
};
